module.exports = __webpack_public_path__ + "static/media/13.291f8dc3.jpg";